import api from "../../config/axios";

export const savequestionsheet = async (file, sheetName, companyId) => {
  try {
    const formData = new FormData();
    formData.append("csv_file", file);
    formData.append("sheet_name", sheetName);
    formData.append("company_id", companyId);
    const response = await api.post(`/save_question_sheet`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// job excel_listing
export const jobexcellisting = async (file, companyId, recruiterId) => {
  try {
    const formData = new FormData();
    formData.append("excel_file", file);
    formData.append("company_id", companyId);
    formData.append("recruiter_id", recruiterId);
    const response = await api.post(`/set_excel_job_listing`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{
  /* New Changes Start*/
}
// save image question
export const saveImagequestion = async (zipFormData, testId) => {
  try {
    // If testId is provided, add it to the formData
    if (testId) {
      zipFormData.append("test_id", testId);
    }
    
    // Log the form data contents for debugging
    console.log("Image upload form data keys:", 
      Array.from(zipFormData.keys()).map(key => `${key}: ${zipFormData.get(key) instanceof File ? zipFormData.get(key).name : 'value present'}`));
    
    const response = await api.post(`/save_question_images`, zipFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    console.log("Image upload response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error saving question image:", error);
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// get the question image
export const getQuestionImage = async (testId) => {
  try {
    const response = await api.post(`/send_question_images`, {
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting question image:", error);
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{
  /* New Changes End*/
}
